import React from 'react';

const EDLHeader = () => {
  return (
    <div className="edl_header">
      <img alt="No Record" src="https://assets.airtel.in/static-assets/b2b-ui-components-lib/images/airtel-business-logo.svg" />
    </div>
  );
};

export default EDLHeader;
